import { FontSizes, FontWeights } from '@fluentui/react';
export var getStyles = function (_a) {
    var theme = _a.theme;
    return {
        root: {
            display: 'flex',
            direction: 'column',
            alignItems: 'center'
        },
        textArea: {
            paddingLeft: '16px',
            overflow: 'hidden',
            '> *': {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            }
        },
        title: {
            color: theme.palette.neutralPrimary,
            fontSize: FontSizes.size14,
            fontWeight: FontWeights.semibold,
            marginBlock: 0
        },
        subtitle: {
            color: theme.palette.neutralSecondary,
            fontSize: FontSizes.size12,
            fontWeight: FontWeights.regular
        }
    };
};
//# sourceMappingURL=CoherencePersona.styles.js.map